import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {User} from '../../../../models/user';
import {RestApiService} from '../../../../services/api/rest-api.service';
import {InputTextModule} from 'primeng/inputtext';
import {ButtonModule} from 'primeng/button';
import {FormsModule} from '@angular/forms';
import {DialogService, DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {InputComponent} from '../../../../components/form/input/input.component';
import {ActionButtonComponent} from '../../../../components/form/action-buttons/action-button.component';
import {ToastService} from '../../../../services/toast.service';
import {CheckboxComponent} from '../../../../components/form/checkbox/checkbox.component';

@Component({
  selector: 'app-user-form',
  templateUrl: './user-form.component.html',
  styleUrls: ['./user-form.component.scss'],
  imports: [
    InputTextModule,
    ButtonModule,
    FormsModule,
    InputComponent,
    ActionButtonComponent,
    CheckboxComponent
  ]
})
export class UserFormComponent implements OnInit {
  userId: number = 0;
  user: User = new User();
  loading = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private api: RestApiService,
    private toastService: ToastService,
    private dynamicDialogRef: DynamicDialogRef, private config: DynamicDialogConfig
  ) {
    this.userId = (config.data as Configuration).userId ?? null;
  }

  ngOnInit(): void {
    // this.route.params.subscribe(params => {
    //   this.userId = params['id'];
    //   if (this.userId) {
    //     this.loadUser(this.userId);
    //   }
    // });
    if (this.userId) {
      this.loadUser(this.userId); // no await
    }
  }

  private async loadUser(userId: number) {
    this.loading = true;
    try {
        const response = await this.api.users.getUserById(userId);
        this.user = response.data;
    } finally {
      this.loading = false;
    }
  }

  async saveUser() {
    this.loading = true;
    try {
      await this.api.users.save(this.user);
      this.toastService.success('Successo', 'Utente salvato con successo');
      this.close();
    } finally {
      this.loading = false;
    }
  }

  close() {
    this.dynamicDialogRef.close();
  }


  static openDialog(dialogService: DialogService, userId: number = 0): DynamicDialogRef {
    return dialogService.open(UserFormComponent, {
      width: '60%',
      closable: true,
      closeOnEscape: true,
      header: 'Utente',
      modal: true,
      showHeader: true,
      data: {
        userId: userId
      } as Configuration
    });
  }

}

interface Configuration {
  userId: number;
}
